<template>
  <div style="margin-left: 20px;margin-right: 30px;">
    <el-col style="font-size: 0.9rem;padding-top: 25px;">
      <el-row>
        <ul class="row-ul">
          <li class="row-li ml-4">
            <el-checkbox-group v-model="checkboxGroupLevel" size="small">
              <el-checkbox-button v-for="level in alarmLevel" :label="level.levelName" :key="level.id"
                   @touchstart.native.prevent="handleLevelSearch(level)" @click.native.prevent="handleLevelSearch(level)"></el-checkbox-button>
            </el-checkbox-group>
          </li>
          <li class="row-li ml-4">
            <el-checkbox-group v-model="checkboxGroupTags" size="small">
              <el-checkbox-button v-for="city in citiesTags" :label="city.name" :key="city.id"
                 @touchstart.native.prevent="handleTagsSearch(city)" @click.native.prevent="handleTagsSearch(city)"></el-checkbox-button>
            </el-checkbox-group>
          </li>
        </ul>
        <ul class="row-ul">
          <li class="mr-0 ml-4 row-li">
            <el-checkbox-group v-model="checkboxGroupDate" size="small">
              <el-checkbox-button v-for="city in citiesDate" :label="city.name" :key="city.value"
                 @touchstart.native.prevent="quickTimeSelection(city)" @click.native.prevent="quickTimeSelection(city)"></el-checkbox-button>
            </el-checkbox-group>
          </li>
          <li class="ml-0 row-li " v-if="checkboxGroupDate.indexOf('自定义')!==-1">
            <el-date-picker
              v-model="screenDate"
              style="width: 100%; height: 30px;margin-top: 1px;"
              size="mini"
              type="daterange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="formChange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </li>
        </ul>
        <ul class="row-ul" style="float: right!important;margin-top: 15px;padding-bottom: 10px;">
          <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="float: right">
            <a type="text" size="mini" @touchstart="() => {this.seniorQuery = !this.seniorQuery}" @click="()=>{this.seniorQuery = !this.seniorQuery}"
               style="color:#299FFB; margin-top: 10px;cursor: pointer">
              {{ this.seniorQuery ? '关闭' : '' }}高级搜索
              <i :class="this.seniorQuery?'el-icon-arrow-up el-icon--right':'el-icon-arrow-down el-icon--right'"></i>
            </a>
          </el-col>
        </ul>
      </el-row>
      <el-row>
        <ul class="row-ul" v-if="this.seniorQuery">
          <li class="row-li  ml-4">
            <div class="d-inline-block" style="width: 70px;">所属空间：</div>
            <el-cascader
              v-model="realTimeForm.space"
              :options="spaces"
              change-on-select="true"
              clearable
              collapse-tags
              filterable
              placeholder="请选择"
              size="mini"
              class="pr-5"
              style="padding-bottom: 5px; width: 220px;">
            </el-cascader>
          </li>
          <li class="row-li  ml-4">
            <div class="d-inline-block" style="width: 70px;">设备类型：</div>
            <el-select
              v-model="realTimeForm.category"
              collapse-tags
              multiple
              placeholder="请选择"
              size="mini"
              class="pr-5"
              style="padding-bottom: 5px; width: 220px;">
              <el-option
                v-for="item in deviceCategory"
                :key="item.id"
                :label="item.cnName"
                :value="item.id">
              </el-option>
            </el-select>
          </li>
        </ul>
        <ul class="row-ul" v-if="this.seniorQuery">
          <li class="row-li  ml-4">
            <div class="d-inline-block" style="width: 70px;">设备名称：</div>
            <el-autocomplete
              v-model="realTimeForm.equipmentName"
              :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb,this.devices,'deviceByName')"
              class="inline-input pr-5"
              placeholder="请输入设备名称"
              size="mini"
              style=" width: 220px;"
            ></el-autocomplete>
          </li>
          <li class="row-li  ml-4">
            <div class="d-inline-block" style="width: 70px;">告警内容：</div>
            <el-autocomplete
              v-model="realTimeForm.msg"
              :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb,this.records,'msg')"
              class="inline-input"
              placeholder="请输入告警内容"
              size="mini"
              style=" width: 185px;"
            ></el-autocomplete>
          </li>
        </ul>
        <ul class="row-ul" style="float: right!important;" v-if="this.seniorQuery">
          <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="float: right">
            <el-button size="mini"
                       style="float:right;font-weight:bold;padding:9px 25px;padding-right: 25px; color:rgba(7, 230, 248, 1)"
                       :loading="isSelect"
                       @touchstart.native="filtrateForm"
                       @click.native="filtrateForm">查询
            </el-button>
          </el-col>
        </ul>
      </el-row>
      <el-row>
        <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24"
                style="margin-top:-18px;border-bottom: 1px solid rgba(41, 155, 255, .2);">
        </el-col>
      </el-row>
      <el-row style="">
        <el-button size="mini" class="button" style="margin-top:-6px;float: right; margin-bottom: 10px;height: 30px;"
               @touchstart.native="exportExcel"    @click.native="exportExcel" :loading="isDownload">
          <img src="../../assets/images/icon/excel.png" style="margin-bottom: 4px;">
          <span style="margin-left: 5px;color: #299FFB">导出</span>
        </el-button>
      </el-row>
      <el-table
        :data="tableData"
        height="55vh"
        style="width: 100%;"
        border>
        <el-table-column
          :formatter="typeFormat"
          align="center"
          label="告警类型">
        </el-table-column>
        <el-table-column
          prop="deviceName"
          align="center"
          label="设备名称">
          <template slot-scope="{row: {deviceName}}">
            {{ deviceName ? deviceName : '无' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="pointName"
          align="center"
          label="测点名称">
          <template slot-scope="{row: {pointName}}">
            {{ pointName ? pointName : '无' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="levelId"
          align="center"
          label="告警级别">
          <template slot-scope="{row: {levelColor,levelName}}">
            <span :style="{'color':levelColor}">{{ levelName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="msg"
          align="center"
          label="内容"
          width="300">
        </el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="告警时间">
        </el-table-column>
        <el-table-column
          prop="ticketNo"
          align="center"
          v-if="tickSystem"
          label="工单编号">
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <a style="color: #60a7f3;cursor: pointer" variant="text" @touchstart="viewLog(scope.row)"  @click="viewLog(scope.row)">查看日志</a>
            <a variant="text" style="color: #60a7f3;cursor: pointer" v-if="scope.row.isLinkageVideo"
             @touchstart="videoLinkageButton(scope.row)"  @click="videoLinkageButton(scope.row)">视频联动</a>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top: 15px;text-align: center" v-if="dateTotal>10">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="defaultForm.pageSize"
          :current-page.sync="defaultForm.pageCurrent"
          :total="dateTotal">
        </el-pagination>
      </el-row>
    </el-col>
    <alarm-handling :visible="deviceDialogVisible"
                    :title="title"
                    alarmId=""
                    :code="code"
                    :idList="idList"
                    opinion=""
                    :activities="activities"
                    @dialogClose="(data) => this.deviceDialogVisible = data"></alarm-handling>

    <!--    弹出告警信息-->
    <alarm-information :visible="videoLinkage"
                       :videoType="videoType"
                       :latestAlarmInformation="latestAlarmInformation"
                       @alarmInformationVisible="(data) => this.videoLinkage = data"></alarm-information>

  </div>
</template>

<script>
import {exportToExcel, historyList} from '@/network/alarm-record';
import {dateFormat, getMsgList, unique} from '@/network/alarm-realtime';
//import {downloadBlobFile} from '@/constant/export-file';
import {getListByParentCode} from '@/network/extension';
import {getAllChildId, getSpaceTreeData} from '@/network/space-info';
import {getLevelList} from "@/network/alarm-level";
import {getDeviceCategoryList} from "@/network/device-category";
import {getDeviceByName} from "@/network/device-info";
import {getType} from "@/constant/alarm-type";
import {listByRecordId, packageList} from "@/network/alarm-log";
import AlarmInformation from "@/components/AlarmInformation";
import AlarmHandling from "@/views/alarm/AlarmHandling";
import {getSystematicByCodes} from "@/network/systematic";

const quickDate = [{name: '全部', value: -1}, {name: '当天', value: 0}, {name: '近一周', value: 7}, {
  name: '近一个月',
  value: 31
}, {name: '近一年', value: 365}, {name: '自定义', value: -2}];
export default {
  name: "History",
  components: {AlarmHandling, AlarmInformation},
  data() {
    return {
      isSelect: false,
      videoLinkage: false,
      videoType: 'history',
      latestAlarmInformation: {},
      checkboxGroupLevel: ['全部'],
      // 标签默认选中
      checkboxGroupTags: ['全部'],
      checkboxGroupDate: ['全部'],
      citiesTags: [{
        id: '-1',
        name: '全部'
      }],
      citiesDate: quickDate,
      seniorQuery: false,
      diaWidth: '',
      diaHeight: '',
      activities: [],
      code: '',
      title: "告警日志",
      deviceDialogVisible: false,
      isDownload: false,
      spaces: [],
      idList: [],
      tags: [{
        value: '1',
        label: '动力'
      }, {
        value: '2',
        label: '环境'
      }, {
        value: '3',
        label: '消防'
      }, {
        value: '4',
        label: '安防'
      }],
      deviceCategory: [{
        value: '选项1',
        label: '非定位漏水'
      }, {
        value: '选项2',
        label: '烟感'
      }, {
        value: '选项3',
        label: '普通空调'
      }, {
        value: '选项4',
        label: '门禁'
      }, {
        value: '选项5',
        label: '列头柜'
      }, {
        value: '选项6',
        label: '四合一'
      }, {
        value: '选项7',
        label: '电表'
      }],
      deviceList: [{
        value: '1',
        label: '艾特ups'
      }, {
        value: '2',
        label: '普通空调'
      }, {
        value: '3',
        label: '温湿度'
      }, {
        value: '4',
        label: '烟感检测'
      }],
      pointList: [{
        value: '选项1',
        label: '温度'
      }, {
        value: '选项2',
        label: '湿度'
      }, {
        value: '选项3',
        label: '温度上限'
      }, {
        value: '选项4',
        label: '温度下限'
      }],
      alarmLevel: [{
        id: '0',
        levelName: '全部',
        levelColor: ''
      }],
      level: '',
      content: '空调',
      value2: [],
      screenDate: '',
      tag: [],
      deviceName: [],
      point: [],
      dateTotal: 0,
      tableData: [],
      // 设备名称
      devices: [],
      // 当前翻页采用参数
      defaultForm: {
        msg: '',
        space: [],
        equipmentType: [],
        //当前页数
        pageCurrent: 1,
        // 每页数
        pageSize: 10,
        levelId: 0,
        //设备名称
        equipmentName: '',
        equipmentLabelList: [],
        startDate: '',
        endDate: '',
        isGatewayOffline: false
      },
      realTimeForm: {
        // 告警内容
        msg: '',
        space: '',
        equipmentName: '',
        category: []
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 3);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 12);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value: '',
      codes: ['tick_system'],
      tickSystem: true,
    }
  },
  mounted() {
    this.getByCodes();
    this.getData(this.defaultForm);
    // 历史查询
    let searchHistory = this.$store.getters.getSearchHistory;
    // 有历史查询
    if (searchHistory !== undefined && searchHistory != null && searchHistory.length > 0) {
      this.records = this.assemblyArray(searchHistory.toString().split(','));
    } else {
      this.records = [];
    }
    getDeviceByName().then(res => {
      if (res.code === 0) {
        let nameList = [];
        if (res.data != null) {
          for (let item of res.data) {
            nameList.push({value: item.name});
          }
          if (nameList.length > 0) {
            this.devices = unique(nameList);
          }
        }
      }
    });
    this.getLevel();
    this.getSpaceTreeData();

  },
  methods: {
    //查询工单系统是否开启
    getByCodes() {
      getSystematicByCodes(this.codes).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.code === "tick_system") {
              console.log(item);
              this.tickSystem = item.val1;
            }
          })
        }
      })
    },

    viewLog(row) {
      this.code = "3";
      this.title = "告警日志";
      this.diaWidth = "60%";
      this.diaHeight = "60vh";
      let id = row.id;
      listByRecordId(id, true).then(res => {
        this.activities = packageList(res.data, row.ticketNo);
        this.deviceDialogVisible = true;
      });
    },
    //视频联动
    videoLinkageButton(row) {
      console.log("联动视频：", row);
      this.latestAlarmInformation = row;
      this.videoLinkage = true;
    },
    // excel导出
    exportExcel() {
      this.isDownload = true;
      let exportForm = this.defaultForm;
      exportForm.pageCurrent = 1;
      exportForm.pageSize = 10000;
      this.$message.info('文件生成中，稍后请前往下载列表中下载文件!')
      exportToExcel(exportForm).then(res => {
        this.isDownload = false;
        if (res) {
          /*downloadBlobFile(res, "告警历史" + dateFormat(new Date(), "yyyyMMdd"));*/
        }
      });
    },
    // 获取数据
    getData(params) {
      this.isSelect = true;
      historyList(params).then(res => {
        if (res.code === 0) {
          // 列表数据
          let bln = res.data == null;
          this.tableData = bln ? null : res.data.records;
          // 总数
          this.dateTotal = bln ? 0 : res.data.total;
          // 每页数
          this.defaultForm.pageSize = bln ? 10 : res.data.size;
          this.defaultForm.pageCurrent = bln ? 1 : res.data.current;
        }
        this.isSelect = false;
      })
    },
    refresh(current) {
      if (current != undefined) {
        this.defaultForm.pageCurrent = 1;
      }
      this.getData(this.defaultForm);
    },
    // 获取告警级别
    getLevel() {
      getLevelList().then(res => {
        if (res.code === 0) {
          this.alarmLevel = this.alarmLevel.concat(res.data);
        }
        this.getTags();
      })
    },// 翻页
    handleCurrentChange(val) {
      //当前为第几页时调用getData()显示第几页数据
      this.defaultForm.pageCurrent = val;
      this.defaultForm.pageSize = 10;
      this.getData(this.defaultForm);
    },
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          let tree = res.data;
          let treeList = this.getTree(tree);
          this.spaces = treeList;
        }
      });
    },
    // 传入一个数组
    getTree(tree) {
      // 返回的数组
      let treeList = [];
      for (let item of tree) {
        // 创建上级选项
        let param = {value: item.id, label: item.title};
        if (item.children != undefined) {
          // 给上级选项添加下级选项
          let childer = this.getTree(item.children);
          param.children = childer;
        }
        treeList.push(param)
      }
      return treeList;
    },
    // 获取告警类型
    typeFormat(data) {
      let type = data.type;
      return getType(type);
    },// 修改告警等级
    handleLevelSearch(val) {
      this.defaultForm.pageCurrent = 1;
      this.defaultForm.pageSize = 10;
      this.defaultForm.levelId = val.id;
      this.checkboxGroupLevel = [val.levelName];
      this.getData(this.defaultForm);
    }, handleTagsSearch(val) {
      this.defaultForm.pageCurrent = 1;
      this.defaultForm.pageSize = 10;
      this.defaultForm.equipmentLabelList = [val.id];
      if (val.id == -1) {
        this.defaultForm.equipmentLabelList = [];
      }
      this.checkboxGroupTags = [val.name];
      this.getData(this.defaultForm);
    }, quickTimeSelection(val) {
      var days = val.value;
      this.checkboxGroupDate = [val.name];
      if (days >= 0) {
        const end = new Date();
        const start = new Date();
        end.setTime(end.getTime() + 3600 * 1000 * 24);
        start.setTime(start.getTime() - 3600 * 1000 * 24 * days);
        this.screenDate = [start, end];
      } else {
        this.screenDate = [];
      }
      if (this.checkboxGroupDate.indexOf('自定义') == -1) {
        this.formChange();
      }
    }, formChange() {
      // 组装表单
      // 设置开始时间
      if (this.screenDate != null && this.screenDate.length > 0) {
        let startTime = this.screenDate[0];
        let endTime = this.screenDate[1];
        this.defaultForm.startDate = dateFormat(startTime, "yyyy-MM-dd");
        // 设置结束时间
        this.defaultForm.endDate = dateFormat(endTime, "yyyy-MM-dd");
      } else {
        this.defaultForm.startDate = '';
        // 设置结束时间
        this.defaultForm.endDate = '';
      }
      this.defaultForm.pageCurrent = 1;
      this.defaultForm.pageSize = 10;
      this.realTimeForm = this.defaultForm;
      this.getData(this.defaultForm);
    }, filtrateForm() {
      // 组装表单
      this.defaultForm.pageCurrent = 1;
      this.defaultForm.pageSize = 10;
      this.defaultForm.msg = this.realTimeForm.msg;
      this.defaultForm.equipmentName = this.realTimeForm.equipmentName;
      if (this.realTimeForm.category != undefined && this.realTimeForm.category.length > 0) {
        this.defaultForm.equipmentType = this.realTimeForm.category;
      } else {
        this.defaultForm.equipmentType = [];
      }
      var space = this.realTimeForm.space.length > 0 ? this.realTimeForm.space[this.realTimeForm.space.length - 1] : '';
      // 获取空间下的所有子空间
      if (space.length > 0) {
        getAllChildId(space).then(res => {
          if (res.code === 0) {
            // 将树转换成需要的格式
            this.space = res.data;
            this.space.push(space);
            this.defaultForm.space = this.space;
            this.getData(this.defaultForm);
          }
        })
      } else {
        this.defaultForm.space = [];
        this.getData(this.defaultForm);
      }
      if (this.defaultForm.msg.length > 0) {
        var newMsg = this.defaultForm.msg;
        let search = this.$store.getters.getSearchHistory;
        if (search != undefined && search.length > 0) {
          let nameList = [];
          if (search != null) {
            for (let item of search.toString().split(",")) {
              nameList.push(item);
            }
            if (nameList.length > 0) {
              nameList.push(newMsg);
            }
            this.$store.commit('setSearchHistory', nameList);
          }
        } else {
          this.$store.commit('setSearchHistory', newMsg);
        }
      }
    },
    assemblyArray(data) {
      let nameList = [];
      if (data != null) {
        for (let item of data) {
          nameList.push({value: item});
        }
        if (nameList.length > 0) {
          return unique(nameList);
        }
      }
    },
    // 获取设备类型
    getDeviceCategoryList() {
      getDeviceCategoryList().then(res => {
        if (res.code === 0) {
          this.deviceCategory = res.data;
          return;
        }
      });
    }, // 获取设备标签
    getTags() {
      getListByParentCode("device_category_tag").then(res => {
        if (res.code === 0) {
          res.data = res.data.filter(item => item.isDisplay);
          this.citiesTags = this.citiesTags.concat(res.data);
        }
        this.getDeviceCategoryList();
      })
    },
    querySearch(queryString, cb, params, type) {
      // 输入停止1s后执行
      var len = queryString.length;
      if (queryString.length == len) {
        // 向远处获取数据 并加入到列表中
        if (type == 'deviceByName') {
          // 获取设备名称
          getDeviceByName(queryString).then(res => {
            if (res.code === 0) {
              let nameList = [];
              if (res.data != null) {
                for (let item of res.data.records) {
                  nameList.push({value: item.name});
                }
                if (nameList.length > 0) {
                  this.devices = unique(nameList);
                }
              }
            }
          });
        } else if (type == 'msg') {
          if (queryString.length === 0) {
            // 历史查询
            let searchHistory = this.$store.getters.getSearchHistory;
            // 有历史查询
            if (searchHistory !== undefined && searchHistory != null && searchHistory.length > 0) {
              this.records = this.assemblyArray(searchHistory.toString().split(','));
            }
          } else {
            // 获取告警内容
            let param = {
              msg: queryString
            };
            getMsgList(param).then(res => {
              if (res.code === 0) {
                let msgList = [];
                if (res.data != null) {
                  for (let msg of res.data) {
                    msgList.push({value: msg});
                  }
                  this.records = unique(msgList);
                }
              }
            });
          }
        }
        setTimeout(() => {
          const records = params;
          const results = queryString ? records == null ? "" : records.filter(this.createFilter(queryString)) : records;
          // 调用 callback 返回建议列表的数据
          cb(results);
        }, 1000);
      }
    },
    createFilter(queryString) {
      return (records) => {
        // 存在即建议
        return (records.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
      };
    },
  }
}
</script>

<style>
.row-li {
  margin: 5px;
  line-height: 30px;
  list-style: none;
  padding: 0;
  float: left !important;
}

.row-ul {
  list-style: none;
  padding: 0;
  float: left !important;
}

@media (max-width: 500px ) {
  .timeSlotChoice {
    float: none;
  }
}

.el-button {
  color: #fff;
  font-size: 0.9rem;
  background-color: rgba(41, 155, 255, .2);
  border: none;
}

.el-button:hover {
  background-color: rgba(41, 155, 255, .4) !important;
  color: #fff;
}
</style>
